import React from "react"

import { getHomePath, getPagePath } from "../utils/pathUtils"
import { Item, List } from "./breadcrumbsStyle"
import Link from "./link"

const Breadcrumbs = ({ page }) => {
  // console.log(page)
  return (
    <List>
      <Item>
        <Link variant="breadcrumbs" to={getHomePath(page.locale)}>
          Home
        </Link>
      </Item>
      {page.treeParent &&
        page.treeParent.treeParent &&
        page.treeParent.treeParent.hide !== true && (
          <Item>
            <Link
              variant="breadcrumbs"
              to={getPagePath(page.treeParent.treeParent)}
            >
              {page.treeParent.treeParent.title ||
                page.treeParent.treeParent.name}
            </Link>
          </Item>
        )}
      {page.treeParent && page.treeParent.hide !== true && (
        <Item>
          <Link variant="breadcrumbs" to={getPagePath(page.treeParent)}>
            {page.treeParent.title || page.treeParent.name}
          </Link>
        </Item>
      )}
      <Item>{page.title || page.name}</Item>
    </List>
  )
}

export default Breadcrumbs
